export default __webpack_public_path__ + "static/media/Launch.5a3470a4.mp4";